const setIn = require("../ImmHelpers").setIn;
const _ = require("lodash");

const settings = {
	neverResumeResult: true,

	noUndoRedoClear: true,
	staticMaxStars: true,
	neverShowSliderMessages: true,

	allowRepeatTrials: true,
	neverSetOutcome: true,
	saveAllProblems: true,
	canEarnStarsOnStateChange: true,
	canFinishOnStateChange: true,
	canEarnStarsOnTrialSubmission: true,
	callPostProcessOnStateChange: true,
	noProblemHistory: true,
	skipProblemCount: true,
};

const computeBackendTrial = function(result, problem, backendTrial) {
	return _.extend({}, backendTrial, {
		outcome: problem.customState.currentOutcome,
		response: {response: parseInt(_.last(backendTrial.response.response)[0])},
		problemData: {factors: _.take(backendTrial.response.response, 2)},
		final: true,
		attemptNumber: 1,
	});
};

const initialize = function(result, processor) {
	const currentProblem = result.problems[0];
	currentProblem.customState = processor.setupCustomState(
		currentProblem.model,
		currentProblem.customState
	);
};

const getStars = function(result) {
	const currentProblem = result.problems[0];
	const state = currentProblem.customState;

	return state.numStacksCompleted;
};

const getTrialXP = function(result) {
	return 1;
};

const getPercentComplete = function(result) {
	const currentProblem = result.problems[0];
	const state = currentProblem.customState;

	let percentComplete;

	if (state.numStacksCompleted >= 3) {
		percentComplete = 1;
	} else {
		percentComplete =
			1 - Math.max(0, state.numProblemsRemaining) / state.numProblemsStart;
	}

	return percentComplete;
};

const isFinished = function(result) {
	const currentProblem = result.problems[0];

	return !!currentProblem.outcome || !!currentProblem.customState.isFinished;
};

const isCurrentProblemDone = function(result) {
	return isFinished(result);
};

const processPostSubmission = function(result, processor, fromStateChange) {
	const currentProblem = result.problems[0];
	const problemModel = currentProblem.model;
	const customState = currentProblem.customState;
	const newCustomState = processor.updateCustomState(
		problemModel,
		customState,
		currentProblem.trials,
		fromStateChange
	);
	return setIn(result, ["problems", 0, "customState"], newCustomState);
};

const canGoToNextProblem = function(result) {
	return true;
};

const getResultProgressXP = function(backendResult) {
	const {progress} = backendResult;
	const numCorrect = _.get(progress, "problems.0.customState.numCorrect") || 0;
	return numCorrect * getTrialXP();
};

const getSummaryProblemsSolvedText = function(result) {
	const stars = getStars(result);

	let endString;

	if (stars === 0) {
		endString = "0 snowmen.";
	} else if (stars === 1) {
		endString = "1 snowman!";
	} else {
		endString = stars + " snowmen!";
	}

	return "You built " + endString;
};

const getStarProgressInfo = function(result) {
	const starCutoffs = [1, 2 / 3, 1 / 3];
	return {
		styleType: result.styleType,
		filledAmount: (getStars(result) * 1) / 3,
		totalAmount: 1,
		allCutoffs: starCutoffs,
		starCutoffs,
		keepStarsReached: true,
	};
};

const getSummaryForReport = function(backendResult) {
	const customState = _.get(backendResult, "progress.problems[0].customState");
	if (!customState) {
		return "Problems cannot be displayed for this game lesson.";
	} else {
		const {
			numProblemsStart,
			numProblemsRemaining,
			numCorrect,
			numSnowballsStart,
			numSnowballsRemaining,
		} = customState;
		if (_.isInteger(numCorrect)) {
			return `${numCorrect}/${numProblemsStart -
				numProblemsRemaining} problems answered correctly.`;
		} else if (
			_.isInteger(numProblemsStart) &&
			_.isInteger(numProblemsRemaining)
		) {
			return `${numProblemsStart - numProblemsRemaining} problems answered.`;
		} else if (
			_.isInteger(numSnowballsStart) &&
			_.isInteger(numSnowballsRemaining)
		) {
			return `${numSnowballsStart - numSnowballsRemaining} problems answered.`;
		} else {
			return "Data unavailable for this lesson.";
		}
	}
};

module.exports = {
	settings,
	initialize,
	getStars,
	getTrialXP,
	getPercentComplete,
	isFinished,
	processPostSubmission,
	canGoToNextProblem,
	getResultProgressXP,
	isCurrentProblemDone,
	getSummaryProblemsSolvedText,
	computeBackendTrial,
	getStarProgressInfo,
	getSummaryForReport,
};
